import { useEffect, useState } from 'react';

const DEFAULT_IGNORED_SELECTOR =
  'input, textarea, select, [contenteditable="true"]';

export const useBoardCanvasHotkeys = options => {
  const { ignoredSelector = DEFAULT_IGNORED_SELECTOR } = options || {};
  const [isSpacePressed, setIsSpacePressed] = useState(false);

  useEffect(() => {
    const onKeyDown = event => {
      if (event.key !== ' ' && event.code !== 'Space') {
        return;
      }
      const target = event.target;
      if (target?.closest?.(ignoredSelector)) {
        return;
      }
      setIsSpacePressed(true);
    };

    const onKeyUp = event => {
      if (event.key === ' ' || event.code === 'Space') {
        setIsSpacePressed(false);
      }
    };

    const onWindowBlur = () => {
      setIsSpacePressed(false);
    };

    window.addEventListener('keydown', onKeyDown);
    window.addEventListener('keyup', onKeyUp);
    window.addEventListener('blur', onWindowBlur);
    return () => {
      window.removeEventListener('keydown', onKeyDown);
      window.removeEventListener('keyup', onKeyUp);
      window.removeEventListener('blur', onWindowBlur);
    };
  }, [ignoredSelector]);

  return { isSpacePressed };
};
